var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideList,
          expression: "hideList"
        }
      ],
      staticClass: "switch-wrapper __pointer",
      on: { click: _vm.toggleList }
    },
    [
      _c(
        "span",
        {
          staticClass: "list-title",
          class: {
            down: !_vm.isShowList,
            up: _vm.isShowList,
            "not-allowed": _vm.notAllowed
          }
        },
        [_vm._v(_vm._s(_vm.title || (_vm.selected && _vm.selected.name)))]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowList,
              expression: "isShowList"
            }
          ],
          staticClass: "list"
        },
        _vm._l(_vm.optList, function(item) {
          return _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selected !== _vm.value,
                  expression: "selected !== value"
                }
              ],
              key: item.value,
              staticClass: "item",
              on: {
                click: function($event) {
                  return _vm.select(item)
                }
              }
            },
            [
              _c("div", { staticClass: "name" }, [
                _vm._v(
                  "\n                " + _vm._s(item.name) + "\n            "
                )
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }